// extracted by mini-css-extract-plugin
var _1 = "SlidesList_isV2__73107";
var _2 = "SlidesList_list__7a7d7";
var _3 = "SlidesList_listWrapper__77961";
var _4 = "SlidesList_nodeWrapper__5d080";
var _5 = "SlidesList_slide__702dd";
export { _1 as "isV2", _2 as "list", _3 as "listWrapper", _4 as "nodeWrapper", _5 as "slide" }
